import ProductListPage from 'ai/components/EntryPoint/ProductListPage/ProductListPage';
import { withProductListPageProps } from 'ai/viewModel/entryPoint/withProductListPageProps';

export default withProductListPageProps(ProductListPage);
